import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { MessagesConstants } from '@shared/constants/messages.constants';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { ActivityType } from '@shared/services/gql.service';

interface AgAdjustmentDiscountTooltipParams extends ICellRendererParams {
  hasPermission: boolean;
  isInEditMode: BehaviorSubject<boolean>;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, AsyncPipe],
  selector: 'aux-ag-adjustment-discount-tooltip-column',
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        position: relative;
      }
    `,
  ],
  template: `
    @if (params.isInEditMode | async) {
      <div
        class="absolute h-full w-full bg-transparent"
        auxTooltip
        [template]="getTooltipTemplate(doNotHavePermissionTmp, discountTooltipTemplate)"
      ></div>
    }
    <ng-template #discountTooltipTemplate>
      <div class="space-y-1">{{ discountTooltipMsg }}</div>
    </ng-template>
    <ng-template #doNotHavePermissionTmp>
      <div class="space-y-1">{{ doNotHavePermissionMsg }}</div>
    </ng-template>
    <div>
      <span>{{ params.valueFormatted }}</span>
    </div>
  `,
})
export class AgAdjustmentDiscountTooltipComponent implements ICellRendererAngularComp {
  activityTypeIsDiscount = false;
  discountTooltipMsg = 'Discount can be adjusted in the Closing Checklist';
  doNotHavePermissionMsg = MessagesConstants.DO_NOT_HAVE_PERMISSIONS_TO_ACTION;
  params!: AgAdjustmentDiscountTooltipParams;

  agInit(params: AgAdjustmentDiscountTooltipParams) {
    this.params = params;
    this.activityTypeIsDiscount =
      this.params?.data?.activity_type === ActivityType.ACTIVITY_DISCOUNT;
  }

  getTooltipTemplate(
    doNotHavePermissionTmp: TemplateRef<unknown>,
    discountTooltipTemplate: TemplateRef<unknown>
  ): TemplateRef<unknown> | undefined {
    if (!this.params.hasPermission) {
      return doNotHavePermissionTmp;
    }

    if (this.activityTypeIsDiscount) {
      return discountTooltipTemplate;
    }

    return undefined;
  }

  refresh(): boolean {
    return false;
  }
}
